import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section } from './Section';
import { courses } from '../data/content';
export function Included() {
  return <Section title="Los 3 cursos" tone="deep" data-id="element-58" data-mp="9btxuamy7jcv">
      <div className="grid grid-cols-1 gap-px overflow-hidden rounded-2xl bg-ink-line md:grid-cols-3" data-id="element-59" data-mp="4dsctk5yp9yr">
        {courses.map(course => <article key={course.label} className="flex flex-col bg-cream p-7 md:p-8" data-id="element-60" data-mp="3vis6z7m8cmur">
            <span className="text-sm font-semibold uppercase tracking-wide text-terracotta" data-id="element-61" data-mp="x2r2d2cezee3">
              {course.label}
            </span>
            <h3 className="mt-2 font-serif text-3xl leading-tight text-ink" data-id="element-62" data-mp="n4tc69azv7iu">{course.title}</h3>
            <ul className="mt-6 space-y-3 text-base leading-relaxed text-ink-soft" data-id="element-63" data-mp="i608t9pf8wwe">
              {course.bullets.map(bullet => <li key={bullet} className="flex gap-3" data-id="element-64" data-mp="37wdbjzj24jf3">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-terracotta" aria-hidden="true" data-id="element-65" data-mp="32w7ge9dkwes9" />
                  <span data-id="element-66" data-mp="35s33fdy0n598">{bullet}</span>
                </li>)}
            </ul>
          </article>)}
      </div>
    </Section>;
}